export const COMMAND_ERROR_CODES = [
  "INVALID_COMMAND",
  "UNAUTHORIZED",
  "HOST_ONLY",
  "ROOM_NOT_JOINABLE",
  "PLAYER_NOT_READY",
  "NOT_YOUR_TURN",
  "WRONG_PHASE",
  "CARD_NOT_IN_HAND",
  "ILLEGAL_PLACEMENT",
  "BROKEN_TOOL",
  "INVALID_TARGET",
  "STALE_VERSION",
  "COMMAND_ID_REUSED",
  "ROOM_EXPIRED",
  "PERSISTENCE_FAILED",
] as const;

export type CommandErrorCode = (typeof COMMAND_ERROR_CODES)[number];

export const PUBLIC_ERROR_CODES = [...COMMAND_ERROR_CODES, "ROOM_NOT_FOUND"] as const;

export type PublicErrorCode = (typeof PUBLIC_ERROR_CODES)[number];
